export default "__VITE_ASSET__BaL5vEQl__"